import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  row: { display: 'inline-flex', alignItems: 'center', gap: 6 },
  colon: { fontWeight: 600 },
});

const pad = (n) => `0${n}`.slice(-2);
const HOURS = Array.from({ length: 24 }, (_, i) => pad(i));
const MINUTES = Array.from({ length: 60 }, (_, i) => pad(i));

// Время «часы : минуты» в 24-часовом формате. Вместо системного окошка выбора времени (оно
// зависит от браузера, с AM/PM и вылезает поверх страницы) — два обычных списка.
function TimeField({ value, onChange, size = 'medium', 'aria-label': ariaLabel = 'Время' }) {
  const classes = useStyles();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');
  const hours = match ? match[1] : '';
  const minutes = match ? match[2] : '';

  const change = (nextHours, nextMinutes) => {
    // Пока выбрана только половина, вторая считается нулём: время всегда получается целым.
    onChange(`${nextHours || '00'}:${nextMinutes || '00'}`);
  };

  const field = (list, current, label, handler) => (
    <TextField
      select
      size={size}
      variant="outlined"
      value={current}
      onChange={(event) => handler(event.target.value)}
      SelectProps={{ native: true }}
      inputProps={{ 'aria-label': label }}
    >
      {current === '' && <option value="" />}
      {list.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </TextField>
  );

  return (
    <span className={classes.row} role="group" aria-label={ariaLabel}>
      {field(HOURS, hours, `${ariaLabel}: часы`, (next) => change(next, minutes))}
      <span className={classes.colon}>:</span>
      {field(MINUTES, minutes, `${ariaLabel}: минуты`, (next) => change(hours, next))}
    </span>
  );
}

export default TimeField;
